import { useQuery } from '@tanstack/react-query';
import { client } from '../../api';
import type { TasksResponse } from '../../api';
import { formatTaskData } from './utils';
import { MIN_SEARCH_LENGTH } from '../../constants';

/**
 * Hook to search tasks across all status tabs.
 * Used for the search preview dropdown in TasksTable.
 *
 * @param searchTerm - The search term to filter tasks by
 * @param enabled - Whether the query should be enabled (default: true when searchTerm has MIN_SEARCH_LENGTH+ characters)
 */
export const useSearchTasks = (searchTerm: string, enabled: boolean = searchTerm.length >= MIN_SEARCH_LENGTH) => {
  return useQuery<TasksResponse>({
    queryKey: ['tasks', 'search', searchTerm],
    queryFn: () =>
      client
        .get('/tasks', {
          params: {
            search: searchTerm,
          },
        })
        .then((res) => {
          res.data.tasks = formatTaskData(res.data.tasks);
          return res.data;
        }),
    enabled,
    // Keep previous data while fetching new results for smoother UX
    placeholderData: (previousData) => (searchTerm.length >= MIN_SEARCH_LENGTH ? previousData : undefined),
  });
};
